/**
 * @alpha
 */
export var CodeEditorSuggestionItemKind;
(function (CodeEditorSuggestionItemKind) {
    CodeEditorSuggestionItemKind["Method"] = "method";
    CodeEditorSuggestionItemKind["Field"] = "field";
    CodeEditorSuggestionItemKind["Property"] = "property";
    CodeEditorSuggestionItemKind["Constant"] = "constant";
    CodeEditorSuggestionItemKind["Text"] = "text";
})(CodeEditorSuggestionItemKind || (CodeEditorSuggestionItemKind = {}));
//# sourceMappingURL=types.js.map